import React from 'react';
import { Box } from '@mui/material';
import CenteredModal from '../CenteredModal';
import PrivilegeCheckboxes from '../../PrivilegeCheckboxes';
import { TextTitle } from '../../Text';
import CloseModalButton from '../../Buttons/CloseModalButton';
import CustomButton from '../../Buttons/CustomButton';

export default function ModalPrivileges({
  open,
  close,
  privilegeData,
  setRole,
  onChange,
  onSave,
}) {
  return (
    <CenteredModal
      containerSx={{ width: '90vw', maxWidth: '1400px' }}
      close={close}
      open={open}
    >
      <Box m={4}>
        <Box
          mb={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <TextTitle h1>Управление правами</TextTitle>
          <CloseModalButton close={close} />
        </Box>

        <PrivilegeCheckboxes
          privilegeData={privilegeData}
          setRole={setRole}
          onChange={onChange}
          showOnlyTsoo={true}
        />

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <CustomButton onClick={onSave} variant="contained">
            Применить
          </CustomButton>
        </Box>
      </Box>
    </CenteredModal>
  );
}
